module.exports = __webpack_public_path__ + "img/bw1player.c9c8ef91.svg";